import _ from 'lodash';
import $ from 'jquery';
import module from 'module';
import moment from "moment/moment";

import './report-filter.style.less';
import templateUrl from './report-filters.template.html';

module.component('reportFilters', {
  templateUrl: templateUrl,
  bindings: {
    /**
     config : {
        reportCode: 'PawnedItemsReport',
        buttons : {
          filter : {
            isVisible : true,
            isDisabled : false,
            action: () => {},
            text: 'Filter'
          }, download : {
            isVisible : true,
            isDisabled : false,
            action: () => {},
            text: 'Download xls'
          }, print : {
            isVisible : false,
            isDisabled : false,
            action: () => {},
            text: 'Print'
          }, downloadBSRFile : {
            isVisible : false,
            isDisabled : false,
            action: () => {},
            text: 'Download BSR',
          }
        }
     }
     */
    config: '<',
    params: '=',
    /**
     * When TRUE date range filter can be empty, otherwise a date must be always provided
     */
    dateRangeOptional: '<'
  },
  controller: function (http, $element, postingDateService, authentication) {
    let that = this;
    const reportCode = that.config.reportCode;

    http.get(`/reports/${reportCode}/filter-definitions`)
      .success(filterDefinition => {
        that.filterDefinition = filterDefinition;
        that.applyDefaults();
        that.processFilterDefinition();
      });

    that.applyDefaults = () => {
      const params = that.params;
      const evaluateCondition = (condition) => {
        /*
          Condition has the following format:
          {
            value: 'xyz'
          }

          {
            code: 'xyz',
            item: 'id',
            condition: nestedCondition
          }

          {
            conditions: [nestedCondition]
          }
         */
        if (condition.value !== undefined) {
          return condition.value;
        }

        const nestedConditions = condition.conditions;
        if (nestedConditions) {
          return nestedConditions.map(c => evaluateCondition(c))
            .find(value => value !== undefined);
        }

        if (condition.condition) {
          const {code, item} = condition;
          if (params[code] === item || (Array.isArray(params[code]) && params[code].includes(item))) {
            return evaluateCondition(condition.condition);
          }
        }
      };

      const applyDefaults = () => {
        let changed = false;
        that.filterDefinition.forEach(filter => {
          // if there is already a value in target filter, skip checking.
          // Null value is allowed because it means "all values"
          if (params[filter.code] !== undefined) {
            return;
          }

          // grab property holding default config
          const defaultCondition = filter['default'];
          // calculate recursively default value
          const defaultValue = defaultCondition && evaluateCondition(defaultCondition);
          if (defaultValue !== undefined) {
            // Set parameter if default is null, meaning select "all values"
            params[filter.code] = defaultValue;
            changed = true;

            const animationClass = 'autofilled-with-default';
            const $elementToAnimate = $element.find(`.filter-code-` + $.escapeSelector(`${filter.code}`));

            $elementToAnimate.one('transitionend webkitTransitionEnd oTransitionEnd', () => {
              $elementToAnimate.removeClass(animationClass);
            });

            requestAnimationFrame(() => {
              $elementToAnimate.addClass(animationClass);
            })
          }
        });

        return changed; // true if we changed default value of any parameter
      };

      // applying one default value can trigger other default to be valid
      // so let's try applying defaults at most a couple times if we still see
      // some changes. However, prevent infinite loop if there is some bug in applyDefault...
      let iteration = 1;
      while (applyDefaults() && iteration < 5) {
        iteration += 1;
      }

      if (iteration >= 5) {
        console.error('Defaults infinite loop!')
      }
    };

    that.onFilterChange = (filterCode) => {
      that.applyDefaults();
      that.processFilterDefinition(filterCode);
    };

    const DATE_FILTERS = ['DAY', 'MONTH', 'YEAR', 'DATE_RANGE'];

    const isContextFiltered = filter =>
      // if the filter's context hasn't changed the size we can assume it was not modified
      _.find(that.filterDefinition, {code: filter.code}).context.length !== filter.context.length;

    that.processFilterDefinition = (filterCode) => {
      that.effectiveFilterDefinition = _.cloneDeep(that.filterDefinition);

      for (let filter of that.effectiveFilterDefinition) {
        if (!filter.context) continue;
        filter.context = _.filter(filter.context, ctx => filterByCondition(ctx.condition));
      }

      // set selected param values which are not longer visible to null
      for (let filter of that.effectiveFilterDefinition) {
        // Date filters with default value null - will reset date to 1970. Make undefined.
        if (DATE_FILTERS.includes(filter.type) && that.params[filter.code] == null) {
          that.params[filter.code] = undefined;
        }
        // for now only single choice list if fully supported
        if (filter.type === 'SINGLE_CHOICE_LIST' || filter.type === 'MULTIPLE_CHOICE_LIST') {
          let paramValue = that.params[filter.code];
          if (!paramValue) continue;

          // param that was selected is not visible anymore. Kill it!
          if (filter.type === 'MULTIPLE_CHOICE_LIST') {
            const isAllOption = paramValue.length === 1 && paramValue[0] === null;

            if (isAllOption && isContextFiltered(filter)) {
              // 'SELECT ALL' is picked but user has restricted options, take all from the filtered context
              paramValue = filter.context.map(c => c.id);
            }

            if (!isAllOption || isContextFiltered(filter)) {
              that.params[filter.code] = _.intersection(_.map(filter.context, 'id'), paramValue);
            }
          } else if (!_.find(filter.context, {id: paramValue})) {
            if (filter['default'] && filter['default'].value) {
              // Fallback to default value if it is included in context
              let isDefaultAllowed = _.find(filter.context, {id: filter['default'].value});
              that.params[filter.code] = isDefaultAllowed ? filter['default'].value : null;
            }

            paramValue = that.params[filter.code];
            if (filter.type === 'SINGLE_CHOICE_LIST' && !_.find(filter.context, {id: paramValue})) {
              // When still nothing was found then pick the first one available
              // The model behind SINGLE_CHOICE_LIST filter is always supposed to contain a value from the context
              // otherwise report can't be generated, empty context is also not allowed
              that.params[filter.code] = filter.context[0].id;
            }
          }
        }
      }

      if (filterCode !== undefined /* initialization*/ && filterCode !== 'branchId' /* non-branch filter changed */) {
        return;
      }

      // branch id is already updated, id-based computation is free to go
      that.effectiveFilterDefinition
        .filter(filter => DATE_FILTERS.includes(filter.type))
        .forEach(filter => setFilterSelectedBranchPostingDate(filter.type, filter.code));
    };

  const setFilterSelectedBranchPostingDate = (filterType, filterCode) => {
    switch (filterType) {
      case 'DATE_RANGE':
        setPostingDateToDateRangeFilter(filterCode);
        break;
      case 'DAY':
        setPostingDateToDateDayFilter(filterCode);
        break;
      case 'MONTH':
        setPostingDateToDateMonthFilter(filterCode);
        break;
      case 'YEAR':
        setPostingDateToDateYearFilter(filterCode);
        break;
    }
  };

  const setPostingDateToDateRangeFilter = async (dateFilterCode) => {
    const postingDate = await resolvePostingDate();
    if (!that.params[dateFilterCode]) that.params[dateFilterCode] = {};
    that.params[dateFilterCode].from = moment(postingDate).format('YYYY-MM-DD');
    that.params[dateFilterCode].to = moment(postingDate).format('YYYY-MM-DD');
  };

  const setPostingDateToDateDayFilter = async (dateFilterCode) => {
    const postingDate = await resolvePostingDate();
    that.params[dateFilterCode] = moment(postingDate).format('YYYY-MM-DD');
  };

  const setPostingDateToDateMonthFilter = async (dateFilterCode) => {
    const postingDate = await resolvePostingDate();
    // some features require month value before the current branch one
    that.month = new Date(moment(postingDate).subtract(1, 'MONTH').format('YYYY-MM'));
    that.formatMonthDate(dateFilterCode);
  };

  const setPostingDateToDateYearFilter = async (dateFilterCode) => {
    const postingDate = await resolvePostingDate();
    // this is used to calculate last day in the given year, subtraction solves an issue of the result past posting date
    that.params[dateFilterCode] = parseInt(moment(postingDate).subtract(1, 'YEAR').format('YYYY'));
  };

  const resolvePostingDate = async () => {
    const branchId = await getBranchId();

    if (Array.isArray(branchId)) {
      const postingDates = await postingDateService.getPostingDateByBranchIds(branchId);
      return getEarliestDate(postingDates);
    }

    return await postingDateService.getPostingDateByBranchId(branchId);
  };

  const getBranchId = () => {
    const branchIdCandidate = that.params.branchId;
    if (branchIdCandidate == null ||
        (Array.isArray(branchIdCandidate) && branchIdCandidate[0] == null)) {
      return authentication.context.branchIds;
    }
    return branchIdCandidate;
  };

  const getEarliestDate = (array) =>
      array.sort((a, b) => new Date(a).getTime() - new Date(b).getTime())[0];

  /**
     * Returns true if the conditions are met
     */
    function filterByCondition(conditions) {
      if (!conditions) return true;

      for (let paramKey of Object.keys(conditions)) {
        if (!conditionMatches(conditions, paramKey))
          return false;
      }
      return true;
    }

    function conditionMatches(conditions, paramKey) {
      // fetch the currently set param value
      // use null instead of undefined to be consistent with "all values"
      let value = that.params[paramKey];
      if (value == null || _.isEqual([null], value) ){
        let def = _.find(that.filterDefinition, {code: paramKey});
        value = def.context.map(c => c.id);
      }
      const conditionValue = conditions[paramKey];
      if (conditionValue instanceof Array) {

        //To compare array values from both params and conditions
        if  (value instanceof  Array) {
          if (_.intersection(conditionValue, value).length === 0) return false;
        } else {
          if (!_.includes(conditionValue, value)) return false;
        }
      } else {

        // check if parameter value is array
        if (value instanceof  Array) {
          if (_.includes(value, conditionValue)) return true;
        }

        // assume it's an object
        if (conditionValue !== value) return false;
      }
      return true;
    }

    that.formatMonthDate = (filterCode) => {
      that.params[filterCode] = moment(that.month).format('YYYY-MM-DD');
    };
  }
});
